module.exports = __webpack_public_path__ + "media/pricing/Professional-1fea719e.png";